import { createAction, props } from "@ngrx/store";

export const actionChangeInSideMenuStatus = createAction(
  '[SideMenu] Status Change',
  props<{ sideMenuIsOpen: boolean }>()
);
